import ReactDOM from 'react-dom/client'
import { AppLayout } from './config/AppLayout'
import './index.css'
import { BrowserRouter } from 'react-router-dom'
import { initializeMetricsDataSource } from './services/MetricsService'
import { initializeYfilesRenderer } from './services/YfilesRendererService'
import { AuthProvider } from './services/AuthContext'

initializeMetricsDataSource();
initializeYfilesRenderer();

ReactDOM.createRoot(document.getElementById('root')!).render(
  // <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <AppLayout />
      </AuthProvider>
    </BrowserRouter>
  // </React.StrictMode>,
)